
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/residential-and-commercial-electrical-services-sydney/solar-panel-and-battery-installations-sydney",
      function () {
        return require("private-next-pages/services/residential-and-commercial-electrical-services-sydney/solar-panel-and-battery-installations-sydney.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/residential-and-commercial-electrical-services-sydney/solar-panel-and-battery-installations-sydney"])
      });
    }
  